var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 985.74,
    height: 1080,
    viewBox: "0 0 985.74 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M263.37,503.962h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM278.37,502.462h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.37,511.462h1.5v-1.5h1.5v-1.5h1.5v-6h3v6h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM288.87,514.462h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM303.87,502.462h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.37,518.962h16.5v-16.5h3v19.5h-3v-1.5h-16.5v-1.5ZM311.37,506.962h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM314.37,506.962v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.87,511.462h4.5v-3h3v3h7.5v-9h3v4.5h4.5v1.5h-4.5v6h-3v-1.5h-15v-1.5ZM342.87,502.462h12v6h-1.5v1.5h-3v-1.5h1.5v-4.5h-9v-1.5ZM344.37,514.462h3v6h13.5v1.5h-15v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.87,511.462h1.5v-1.5h1.5v-1.5h1.5v-6h3v6h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM368.37,514.462h18v6h-1.5v1.5h-15v-1.5h-1.5v-6ZM371.37,515.962v4.5h12v-4.5h-12ZM383.37,502.462h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.87,518.962h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM405.87,502.462h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.87,503.962h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-12h-6v-1.5ZM429.87,502.462h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.37,502.462h3v4.5h6v-4.5h3v9h-1.5v1.5h-9v-1.5h-1.5v-9ZM447.87,514.462h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM449.37,508.462v3h6v-3h-6ZM458.37,505.462h4.5v-3h3v10.5h-3v-3h-4.5v-1.5h4.5v-1.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.37,503.962h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h1.5v1.5h1.5v3h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-3h1.5v-1.5h1.5v-1.5h-3v-1.5ZM470.37,518.962h4.5v-4.5h3v4.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM473.37,508.462v3h1.5v1.5h3v-1.5h1.5v-3h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37,503.962h4.5v-1.5h3v1.5h4.5v1.5h-12v-1.5ZM494.37,509.962h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v7.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-7.5ZM497.37,509.962v7.5h1.5v1.5h3v-1.5h1.5v-7.5h-1.5v-1.5h-3v1.5h-1.5ZM509.37,502.462h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.37,518.962h9v-7.5h3v7.5h9v1.5h-21v-1.5ZM519.87,503.962h18v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.87,511.462h21v1.5h-9v3h-3v-3h-9v-1.5ZM551.37,503.962h7.5v-1.5h3v1.5h7.5v1.5h-6v1.5h1.5v1.5h4.5v1.5h-6v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-6v-1.5h4.5v-1.5h1.5v-1.5h-6v-1.5ZM551.37,514.462h18v6h-1.5v1.5h-1.5v-6h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.87,502.462h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM575.37,514.462h18v6h-1.5v1.5h-1.5v-6h-15v-1.5ZM585.87,506.962h4.5v-4.5h3v10.5h-3v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.87,518.962h4.5v-4.5h3v4.5h9v-16.5h3v19.5h-3v-1.5h-16.5v-1.5ZM597.87,503.962h12v1.5h-9v7.5h9v1.5h-10.5v-1.5h-1.5v-9Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.87,511.462h21v1.5h-21v-1.5ZM623.37,502.462h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM623.37,514.462h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.37,518.962h4.5v-7.5h3v7.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM653.37,503.962h12v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-9v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.37,502.462h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM678.87,515.962h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM681.87,517.462v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM689.37,506.962h4.5v-4.5h3v10.5h-3v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.37,511.462h21v1.5h-21v-1.5ZM702.87,503.962h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM702.87,514.462h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM705.87,505.462v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.62,537.262h3v4.5h-1.5v1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,538.762h10.5v1.5h-7.5v13.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM264.12,537.262h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,538.762h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM288.12,537.262h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.62,537.262h12v1.5h-9v3h9v1.5h-9v3h9v1.5h-10.5v-1.5h-1.5v-9ZM297.12,549.262h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM307.62,541.762h4.5v-4.5h3v10.5h-3v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.12,546.262h21v1.5h-9v3h-3v-3h-9v-1.5ZM328.62,537.262h18v1.5h-3v4.5h3v1.5h-18v-1.5h3v-4.5h-3v-1.5ZM328.62,550.762h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM331.62,552.262v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM334.62,538.762v4.5h6v-4.5h-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.12,538.762h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h1.5v1.5h1.5v3h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-3h1.5v-1.5h1.5v-1.5h-3v-1.5ZM351.12,553.762h4.5v-4.5h3v4.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM354.12,543.262v3h1.5v1.5h3v-1.5h1.5v-3h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.62,537.262h3v4.5h-1.5v1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.62,538.762h10.5v7.5h-7.5v7.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-9h7.5v-4.5h-7.5v-1.5ZM394.62,537.262h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.62,546.262h21v1.5h-21v-1.5ZM405.12,537.262h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM405.12,549.262h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.12,538.762h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-12h-6v-1.5ZM448.62,537.262h3v9h1.5v-9h3v19.5h-3v-9h-1.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.12,537.262h3v9h9v1.5h-10.5v-1.5h-1.5v-9ZM460.62,549.262h18v6h-1.5v1.5h-15v-1.5h-1.5v-6ZM463.62,550.762v4.5h12v-4.5h-12ZM471.12,540.262h4.5v-3h3v10.5h-3v-3h-4.5v-1.5h4.5v-1.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.12,541.762h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM486.12,541.762v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM493.62,546.262h3v-9h3v19.5h-3v-9h-3v-1.5ZM501.12,537.262h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.62,537.262h3v4.5h6v-4.5h3v9h-1.5v1.5h-9v-1.5h-1.5v-9ZM516.12,555.262h3v-1.5h3v-1.5h1.5v-3h3v3h1.5v1.5h3v1.5h3v1.5h-3v-1.5h-4.5v-1.5h-3v1.5h-4.5v1.5h-3v-1.5ZM517.62,543.262v3h6v-3h-6ZM531.12,537.262h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.62,538.762h10.5v1.5h-7.5v13.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM552.12,537.262h3v9h1.5v-9h3v19.5h-3v-9h-1.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.62,541.762h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM565.62,541.762v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM574.62,546.262h4.5v-9h3v19.5h-3v-9h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.12,553.762h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM610.62,537.262h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.12,537.262h9v9h-1.5v1.5h-6v-1.5h4.5v-7.5h-6v-1.5ZM619.62,549.262h16.5v6h-1.5v1.5h-1.5v-6h-13.5v-1.5ZM633.12,537.262h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.12,538.762h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h1.5v1.5h1.5v3h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-3h1.5v-1.5h1.5v-1.5h-3v-1.5ZM642.12,553.762h4.5v-4.5h3v4.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM645.12,543.262v3h1.5v1.5h3v-1.5h1.5v-3h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.12,538.762h4.5v-1.5h3v1.5h4.5v1.5h-12v-1.5ZM666.12,544.762h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v7.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-7.5ZM669.12,544.762v7.5h1.5v1.5h3v-1.5h1.5v-7.5h-1.5v-1.5h-3v1.5h-1.5ZM681.12,537.262h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.12,540.262h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM691.62,555.262h1.5v-1.5h1.5v-4.5h3v4.5h1.5v1.5h1.5v1.5h-3v-1.5h-3v1.5h-3v-1.5ZM693.12,540.262v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5ZM702.12,540.262h4.5v-3h3v10.5h-3v-3h-4.5v-1.5h4.5v-1.5h-4.5v-1.5ZM702.12,555.262h1.5v-1.5h1.5v-4.5h3v4.5h1.5v1.5h1.5v1.5h-3v-1.5h-3v1.5h-3v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.12,538.762h10.5v1.5h-7.5v13.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM729.12,537.262h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.12,550.762h3v3h-3v-3Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.62,573.562h10.5v1.5h-7.5v13.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM240.12,572.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,573.562h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM264.12,572.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,572.062h12v1.5h-9v3h9v1.5h-9v3h9v1.5h-10.5v-1.5h-1.5v-9ZM273.12,584.062h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM283.62,576.562h4.5v-4.5h3v10.5h-3v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.12,581.062h21v1.5h-9v3h-3v-3h-9v-1.5ZM304.62,572.062h18v1.5h-3v4.5h3v1.5h-18v-1.5h3v-4.5h-3v-1.5ZM304.62,585.562h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM307.62,587.062v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM310.62,573.562v4.5h6v-4.5h-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.12,573.562h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h1.5v1.5h1.5v3h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-3h1.5v-1.5h1.5v-1.5h-3v-1.5ZM327.12,588.562h4.5v-4.5h3v4.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM330.12,578.062v3h1.5v1.5h3v-1.5h1.5v-3h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.12,581.062h21v1.5h-21v-1.5ZM352.62,572.062h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM352.62,584.062h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.62,588.562h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM397.62,572.062h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.62,572.062h12v6h-9v3h9v1.5h-10.5v-1.5h-1.5v-4.5h9v-3h-9v-1.5ZM408.12,584.062h16.5v6h-1.5v1.5h-13.5v-1.5h-1.5v-6ZM411.12,585.562v4.5h10.5v-4.5h-10.5ZM421.62,572.062h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.62,581.062h21v1.5h-21v-1.5ZM432.12,572.062h18v1.5h-15v4.5h15v1.5h-16.5v-1.5h-1.5v-6ZM432.12,584.062h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.62,576.562h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM457.62,576.562v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM471.12,572.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.12,576.562h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM489.12,576.562v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM502.62,572.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.12,581.062h21v1.5h-21v-1.5ZM511.62,572.062h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM511.62,584.062h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.62,581.062h9v-3h3v3h9v1.5h-21v-1.5ZM543.12,572.062h3v3h12v-3h3v6h-1.5v1.5h-15v-1.5h-1.5v-6ZM543.12,584.062h18v6h-1.5v1.5h-1.5v-6h-15v-1.5ZM546.12,576.562v1.5h12v-1.5h-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.62,573.562h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM576.12,581.062h3v-9h3v19.5h-3v-9h-3v-1.5ZM583.62,572.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.62,573.562h4.5v-1.5h3v1.5h4.5v1.5h-12v-1.5ZM589.62,579.562h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v7.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-7.5ZM592.62,579.562v7.5h1.5v1.5h3v-1.5h1.5v-7.5h-1.5v-1.5h-3v1.5h-1.5ZM604.62,572.062h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.62,588.562h9v-7.5h3v7.5h9v1.5h-21v-1.5ZM615.12,573.562h18v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.12,572.062h3v4.5h6v-4.5h3v9h-1.5v1.5h-9v-1.5h-1.5v-9ZM646.62,584.062h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM648.12,578.062v3h6v-3h-6ZM657.12,575.062h4.5v-3h3v10.5h-3v-3h-4.5v-1.5h4.5v-1.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.12,573.562h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h3v4.5h-3v1.5h-6v-1.5h-3v-4.5h3v-1.5h-3v-1.5ZM670.62,585.562h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM672.12,578.062v1.5h1.5v1.5h3v-1.5h1.5v-1.5h-1.5v-1.5h-3v1.5h-1.5ZM673.62,587.062v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM681.12,575.062h4.5v-3h3v10.5h-3v-3h-4.5v-1.5h4.5v-1.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.12,588.562h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM709.62,572.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.12,573.562h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-6h-6v-1.5h6v-4.5h-6v-1.5ZM733.62,572.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.12,581.062h21v1.5h-21v-1.5ZM742.62,572.062h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM742.62,584.062h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.62,623.361h4.5v-7.5h3v7.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM259.62,608.361h12v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-9v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.62,606.861h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM285.12,620.361h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM288.12,621.861v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM295.62,611.361h4.5v-4.5h3v10.5h-3v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.62,611.361h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM310.62,611.361v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM318.12,615.861h3v-9h3v19.5h-3v-9h-3v-1.5ZM325.62,606.861h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.62,623.361h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM343.62,615.861h4.5v-9h3v19.5h-3v-9h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.12,609.861h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM364.62,618.861h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM366.12,609.861v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5ZM379.62,606.861h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.12,611.361h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM390.12,611.361v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM399.12,615.861h4.5v-9h3v19.5h-3v-9h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.12,606.861h3v9h9v1.5h-10.5v-1.5h-1.5v-9ZM412.62,618.861h3v6h13.5v1.5h-15v-1.5h-1.5v-6ZM426.12,606.861h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.12,608.361h10.5v1.5h-7.5v13.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM450.12,606.861h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.12,620.361h3v3h-3v-3Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.12,623.361h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM489.12,606.861h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.12,615.861h4.5v-3h3v3h6v-3h3v3h4.5v1.5h-21v-1.5ZM499.62,608.361h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM499.62,620.361h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM502.62,609.861v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM502.62,621.861v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.12,608.361h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM537.12,606.861h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.12,608.361h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-12h-6v-1.5ZM561.12,606.861h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.62,606.861h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM579.12,618.861h18v6h-1.5v1.5h-1.5v-6h-15v-1.5ZM594.12,606.861h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.62,606.861h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM603.12,618.861h3v3h12v-3h3v6h-1.5v1.5h-15v-1.5h-1.5v-6ZM606.12,623.361v1.5h12v-1.5h-12ZM613.62,611.361h4.5v-4.5h3v10.5h-3v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.12,611.361h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM636.12,611.361v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM649.62,606.861h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.12,608.361h10.5v15h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM660.12,609.861v13.5h4.5v-13.5h-4.5ZM673.62,606.861h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.12,608.361h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM697.62,606.861h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.12,615.861h21v1.5h-21v-1.5ZM706.62,606.861h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM706.62,618.861h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,643.162h3v15h6v-1.5h3v1.5h-1.5v1.5h-9v-1.5h-1.5v-15ZM286.62,641.662h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.62,646.162h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM298.62,646.162v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM312.12,641.662h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.62,643.162h10.5v1.5h-7.5v4.5h7.5v1.5h-7.5v7.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM330.12,650.662h3v-9h3v19.5h-3v-9h-3v-1.5ZM337.62,641.662h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.62,646.162h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM346.62,646.162v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM354.12,650.662h3v-9h3v19.5h-3v-9h-3v-1.5ZM361.62,641.662h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,653.662h21v1.5h-9v6h-3v-6h-9v-1.5ZM376.62,643.162h7.5v-1.5h3v1.5h7.5v1.5h-7.5v3h1.5v1.5h1.5v1.5h4.5v1.5h-6v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-6v-1.5h4.5v-1.5h1.5v-1.5h1.5v-3h-7.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.12,643.162h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-12h-6v-1.5ZM414.12,641.662h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.12,643.162h4.5v-1.5h3v1.5h4.5v1.5h-12v-1.5ZM423.12,649.162h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v7.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-7.5ZM426.12,649.162v7.5h1.5v1.5h3v-1.5h1.5v-7.5h-1.5v-1.5h-3v1.5h-1.5ZM438.12,641.662h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.12,641.662h12v9h-1.5v1.5h-9v-1.5h-1.5v-9ZM448.62,653.662h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM450.12,643.162v7.5h6v-7.5h-6ZM459.12,644.662h4.5v-3h3v10.5h-3v-3h-4.5v-1.5h4.5v-1.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.62,650.662h21v1.5h-9v3h-3v-3h-9v-1.5ZM480.12,641.662h18v1.5h-3v4.5h3v1.5h-18v-1.5h3v-4.5h-3v-1.5ZM480.12,655.162h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM483.12,656.662v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM486.12,643.162v4.5h6v-4.5h-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.62,643.162h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h1.5v1.5h1.5v3h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-3h1.5v-1.5h1.5v-1.5h-3v-1.5ZM502.62,658.162h4.5v-4.5h3v4.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM505.62,647.662v3h1.5v1.5h3v-1.5h1.5v-3h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.62,658.162h16.5v-16.5h3v19.5h-3v-1.5h-16.5v-1.5ZM526.62,646.162h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM529.62,646.162v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.12,650.662h21v1.5h-21v-1.5ZM559.62,643.162h7.5v-1.5h3v1.5h7.5v1.5h-1.5v1.5h1.5v1.5h-1.5v1.5h-15v-1.5h-1.5v-1.5h1.5v-1.5h-1.5v-1.5ZM559.62,653.662h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM562.62,646.162v1.5h12v-1.5h-12Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.12,641.662h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM583.62,653.662h18v6h-1.5v1.5h-1.5v-6h-15v-1.5ZM594.12,646.162h4.5v-4.5h3v10.5h-3v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.12,646.162h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM609.12,646.162v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM622.62,641.662h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.12,650.662h1.5v-1.5h1.5v-7.5h3v6h1.5v-6h3v7.5h1.5v1.5h1.5v1.5h-3v-1.5h-3v1.5h-3v-1.5h-1.5v1.5h-3v-1.5ZM639.12,653.662h6v-1.5h4.5v1.5h6v1.5h-1.5v1.5h1.5v3h-1.5v1.5h-13.5v-1.5h-1.5v-3h1.5v-1.5h-1.5v-1.5ZM640.62,649.162v1.5h1.5v-1.5h-1.5ZM642.12,656.662v3h10.5v-3h-10.5ZM652.62,641.662h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.62,644.662h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM663.12,653.662h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM664.62,644.662v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5ZM678.12,641.662h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.62,643.162h10.5v1.5h-7.5v13.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM700.62,641.662h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.62,655.162h3v3h-3v-3Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.37,685.462h4.5v-3h3v3h7.5v-9h3v4.5h4.5v1.5h-4.5v6h-3v-1.5h-15v-1.5ZM251.37,676.462h12v6h-1.5v1.5h-3v-1.5h1.5v-4.5h-9v-1.5ZM252.87,688.462h3v6h13.5v1.5h-15v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.37,676.462h12v6h-9v3h9v1.5h-10.5v-1.5h-1.5v-4.5h9v-3h-9v-1.5ZM276.87,688.462h16.5v6h-1.5v1.5h-13.5v-1.5h-1.5v-6ZM279.87,689.962v4.5h10.5v-4.5h-10.5ZM290.37,676.462h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.37,677.962h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM314.37,676.462h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.37,685.462h21v1.5h-21v-1.5ZM324.87,676.462h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM324.87,688.462h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.87,685.462h21v1.5h-9v3h-3v-3h-9v-1.5ZM356.37,676.462h18v1.5h-3v4.5h3v1.5h-18v-1.5h3v-4.5h-3v-1.5ZM356.37,689.962h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM359.37,691.462v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM362.37,677.962v4.5h6v-4.5h-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.87,677.962h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h1.5v1.5h1.5v3h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-3h1.5v-1.5h1.5v-1.5h-3v-1.5ZM378.87,692.962h4.5v-4.5h3v4.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM381.87,682.462v3h1.5v1.5h3v-1.5h1.5v-3h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.37,677.962h3v15h6v-1.5h3v1.5h-1.5v1.5h-9v-1.5h-1.5v-15ZM425.37,676.462h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.37,680.962h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM437.37,680.962v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM450.87,676.462h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.37,677.962h10.5v1.5h-7.5v4.5h7.5v1.5h-7.5v7.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM468.87,685.462h3v-9h3v19.5h-3v-9h-3v-1.5ZM476.37,676.462h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.37,692.962h4.5v-4.5h3v4.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM482.37,680.962h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM485.37,680.962v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.37,692.962h16.5v-16.5h3v19.5h-3v-1.5h-16.5v-1.5ZM506.37,680.962h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM509.37,680.962v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.87,685.462h1.5v-1.5h1.5v-1.5h1.5v-6h3v6h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM539.37,689.962h3v-1.5h10.5v1.5h3v4.5h-3v1.5h-10.5v-1.5h-3v-4.5ZM542.37,691.462v1.5h1.5v1.5h7.5v-1.5h1.5v-1.5h-1.5v-1.5h-7.5v1.5h-1.5ZM552.87,676.462h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.87,692.962h9v-4.5h3v4.5h9v1.5h-21v-1.5ZM563.37,679.462h7.5v-3h3v3h7.5v1.5h-3v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5h3v-1.5h-3v-1.5ZM566.37,683.962v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.87,676.462h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM587.37,688.462h16.5v6h-1.5v1.5h-1.5v-6h-13.5v-1.5ZM600.87,676.462h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.87,685.462h4.5v-3h3v3h6v-3h3v3h4.5v1.5h-21v-1.5ZM611.37,677.962h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM611.37,689.962h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM614.37,679.462v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM614.37,691.462v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.37,692.962h4.5v-7.5h3v7.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM641.37,677.962h12v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-9v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.37,676.462h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM666.87,689.962h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM669.87,691.462v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5ZM677.37,680.962h4.5v-4.5h3v10.5h-3v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.37,680.962h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM692.37,680.962v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM699.87,685.462h3v-9h3v19.5h-3v-9h-3v-1.5ZM707.37,676.462h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.37,692.962h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM725.37,685.462h4.5v-9h3v19.5h-3v-9h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,720.262h1.5v-1.5h1.5v-1.5h1.5v-6h3v6h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM249.12,724.762h3v-1.5h13.5v1.5h3v4.5h-3v1.5h-13.5v-1.5h-3v-4.5ZM252.12,726.262v1.5h1.5v1.5h10.5v-1.5h1.5v-1.5h-1.5v-1.5h-10.5v1.5h-1.5ZM261.12,711.262h3v4.5h1.5v-4.5h3v10.5h-3v-4.5h-1.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,711.262h9v9h-1.5v1.5h-6v-1.5h4.5v-7.5h-6v-1.5ZM273.12,723.262h16.5v6h-1.5v1.5h-1.5v-6h-13.5v-1.5ZM286.62,711.262h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.62,727.762h16.5v-16.5h3v19.5h-3v-1.5h-16.5v-1.5ZM295.62,715.762h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM298.62,715.762v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.12,720.262h21v1.5h-9v3h-3v-3h-9v-1.5ZM328.62,712.762h7.5v-1.5h3v1.5h7.5v1.5h-6v1.5h1.5v1.5h4.5v1.5h-6v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-6v-1.5h4.5v-1.5h1.5v-1.5h-6v-1.5ZM328.62,723.262h18v6h-1.5v1.5h-1.5v-6h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.12,711.262h12v1.5h-4.5v4.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-4.5h-4.5v-1.5ZM352.62,723.262h18v6h-1.5v1.5h-1.5v-6h-15v-1.5ZM363.12,715.762h4.5v-4.5h3v10.5h-3v-4.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,727.762h4.5v-7.5h3v7.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM375.12,712.762h12v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-9v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.62,711.262h3v4.5h6v-4.5h3v9h-1.5v1.5h-9v-1.5h-1.5v-9ZM408.12,723.262h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM409.62,717.262v3h6v-3h-6ZM418.62,714.262h4.5v-3h3v10.5h-3v-3h-4.5v-1.5h4.5v-1.5h-4.5v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.62,712.762h4.5v-1.5h3v1.5h4.5v1.5h-3v1.5h1.5v1.5h1.5v3h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-3h1.5v-1.5h1.5v-1.5h-3v-1.5ZM430.62,727.762h4.5v-4.5h3v4.5h7.5v-16.5h3v9h4.5v1.5h-4.5v9h-3v-1.5h-15v-1.5ZM433.62,717.262v3h1.5v1.5h3v-1.5h1.5v-3h-1.5v-1.5h-3v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.62,715.762h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v10.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-10.5ZM457.62,715.762v10.5h1.5v1.5h3v-1.5h1.5v-10.5h-1.5v-1.5h-3v1.5h-1.5ZM465.12,720.262h3v-9h3v19.5h-3v-9h-3v-1.5ZM472.62,711.262h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.12,712.762h10.5v1.5h-7.5v13.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM499.62,711.262h3v9h1.5v-9h3v19.5h-3v-9h-1.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.12,712.762h4.5v-1.5h3v1.5h4.5v1.5h-12v-1.5ZM510.12,718.762h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v7.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-7.5ZM513.12,718.762v7.5h1.5v1.5h3v-1.5h1.5v-7.5h-1.5v-1.5h-3v1.5h-1.5ZM523.62,711.262h3v9h1.5v-9h3v19.5h-3v-9h-1.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.62,714.262h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v4.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-4.5ZM543.12,723.262h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM544.62,714.262v4.5h1.5v1.5h3v-1.5h1.5v-4.5h-1.5v-1.5h-3v1.5h-1.5ZM558.12,711.262h3v10.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.62,712.762h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM582.12,711.262h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.62,712.762h4.5v-1.5h3v1.5h4.5v1.5h-12v-1.5ZM589.62,718.762h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v7.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-7.5ZM592.62,718.762v7.5h1.5v1.5h3v-1.5h1.5v-7.5h-1.5v-1.5h-3v1.5h-1.5ZM604.62,711.262h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.62,727.762h9v-7.5h3v7.5h9v1.5h-21v-1.5ZM615.12,712.762h18v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.12,727.762h21v1.5h-21v-1.5ZM646.62,720.262h4.5v-1.5h1.5v-1.5h1.5v-4.5h3v4.5h1.5v1.5h1.5v1.5h4.5v1.5h-6v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-6v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.12,727.762h21v1.5h-21v-1.5ZM670.62,720.262h4.5v-1.5h1.5v-1.5h1.5v-4.5h3v4.5h1.5v1.5h1.5v1.5h4.5v1.5h-6v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-6v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.12,727.762h9v-4.5h3v4.5h9v1.5h-21v-1.5ZM694.62,712.762h18v6h-15v3h15v1.5h-16.5v-1.5h-1.5v-4.5h15v-3h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.12,720.262h21v1.5h-21v-1.5ZM718.62,711.262h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM718.62,723.262h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.37,746.062h12v1.5h-9v3h9v1.5h-9v3h9v1.5h-10.5v-1.5h-1.5v-9ZM336.87,758.062h16.5v6h-1.5v1.5h-13.5v-1.5h-1.5v-6ZM339.87,759.562v4.5h10.5v-4.5h-10.5ZM350.37,746.062h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.37,758.062h21v1.5h-9v6h-3v-6h-9v-1.5ZM360.87,747.562h18v9h-1.5v1.5h-3v-1.5h1.5v-7.5h-15v-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.37,747.562h4.5v-1.5h3v1.5h4.5v1.5h-12v-1.5ZM383.37,753.562h1.5v-1.5h1.5v-1.5h6v1.5h1.5v1.5h1.5v7.5h-1.5v1.5h-1.5v1.5h-6v-1.5h-1.5v-1.5h-1.5v-7.5ZM386.37,753.562v7.5h1.5v1.5h3v-1.5h1.5v-7.5h-1.5v-1.5h-3v1.5h-1.5ZM398.37,746.062h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.37,755.062h21v1.5h-21v-1.5ZM408.87,746.062h3v6h15v1.5h-16.5v-1.5h-1.5v-6ZM408.87,758.062h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.87,762.562h1.5v-1.5h1.5v-1.5h1.5v-12h3v12h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5ZM455.37,746.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.87,746.062h9v9h-1.5v1.5h-6v-1.5h4.5v-7.5h-6v-1.5ZM464.37,758.062h3v6h13.5v1.5h-15v-1.5h-1.5v-6ZM477.87,746.062h3v4.5h4.5v1.5h-4.5v4.5h-3v-10.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.87,755.062h21v1.5h-21v-1.5ZM488.37,747.562h3v-1.5h12v1.5h3v4.5h-3v1.5h-12v-1.5h-3v-4.5ZM488.37,758.062h18v4.5h-15v1.5h15v1.5h-16.5v-1.5h-1.5v-3h15v-1.5h-15v-1.5ZM491.37,749.062v1.5h1.5v1.5h9v-1.5h1.5v-1.5h-1.5v-1.5h-9v1.5h-1.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.37,747.562h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-12h-6v-1.5ZM533.37,746.062h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.37,747.562h12v1.5h-4.5v10.5h1.5v1.5h1.5v1.5h1.5v1.5h-3v-1.5h-1.5v-1.5h-3v1.5h-1.5v1.5h-3v-1.5h1.5v-1.5h1.5v-1.5h1.5v-10.5h-4.5v-1.5ZM558.87,746.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.37,747.562h9v13.5h-1.5v1.5h-1.5v1.5h-4.5v-1.5h3v-1.5h1.5v-12h-6v-1.5ZM576.87,755.062h3v-9h3v19.5h-3v-9h-3v-1.5ZM584.37,746.062h3v19.5h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.87,755.062h4.5v-3h3v3h9v-9h3v12h-3v-1.5h-16.5v-1.5ZM597.87,746.062h12v1.5h-9v3h9v1.5h-10.5v-1.5h-1.5v-4.5ZM599.37,758.062h3v6h15v1.5h-16.5v-1.5h-1.5v-6Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.87,747.562h10.5v1.5h-7.5v13.5h4.5v-1.5h3v1.5h-1.5v1.5h-7.5v-1.5h-1.5v-15ZM636.87,746.062h3v9h4.5v1.5h-4.5v9h-3v-19.5Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.87,759.562h3v3h-3v-3Z",
    fill: "#000",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M399.495,380.426h31.5v2.25h-13.5v4.5h-4.5v-4.5h-13.5v-2.25ZM401.745,366.926h27v2.25h-4.5v6.75h4.5v2.25h-27v-2.25h4.5v-6.75h-4.5v-2.25ZM401.745,387.176h4.5v-2.25h18v2.25h4.5v6.75h-4.5v2.25h-18v-2.25h-4.5v-6.75ZM406.245,389.426v2.25h2.25v2.25h13.5v-2.25h2.25v-2.25h-2.25v-2.25h-13.5v2.25h-2.25ZM410.745,369.176v6.75h9v-6.75h-9Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.495,369.176h6.75v-2.25h4.5v2.25h6.75v2.25h-4.5v2.25h2.25v2.25h2.25v4.5h-2.25v2.25h-2.25v2.25h-9v-2.25h-2.25v-2.25h-2.25v-4.5h2.25v-2.25h2.25v-2.25h-4.5v-2.25ZM435.495,391.676h6.75v-6.75h4.5v6.75h11.25v-24.75h4.5v13.5h6.75v2.25h-6.75v13.5h-4.5v-2.25h-22.5v-2.25ZM439.995,375.926v4.5h2.25v2.25h4.5v-2.25h2.25v-4.5h-2.25v-2.25h-4.5v2.25h-2.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.745,369.176h4.5v22.5h9v-2.25h4.5v2.25h-2.25v2.25h-13.5v-2.25h-2.25v-22.5ZM505.245,366.926h4.5v13.5h6.75v2.25h-6.75v13.5h-4.5v-29.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.745,373.676h2.25v-2.25h2.25v-2.25h9v2.25h2.25v2.25h2.25v15.75h-2.25v2.25h-2.25v2.25h-9v-2.25h-2.25v-2.25h-2.25v-15.75ZM523.245,373.676v15.75h2.25v2.25h4.5v-2.25h2.25v-15.75h-2.25v-2.25h-4.5v2.25h-2.25ZM543.495,366.926h4.5v29.25h-4.5v-29.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.745,369.176h15.75v2.25h-11.25v6.75h11.25v2.25h-11.25v11.25h6.75v-2.25h4.5v2.25h-2.25v2.25h-11.25v-2.25h-2.25v-22.5ZM570.495,380.426h4.5v-13.5h4.5v29.25h-4.5v-13.5h-4.5v-2.25ZM581.745,366.926h4.5v29.25h-4.5v-29.25Z",
    fill: "#000",
    strokeWidth: 0
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.308,414.029h3.25v4.875h6.5v1.625h1.625v8.125h-1.625v1.625h-9.75v-16.25ZM433.558,420.529v8.125h4.875v-8.125h-4.875Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.308,418.904h3.25v9.75h4.875v-9.75h3.25v14.625h-1.625v1.625h-8.125v-1.625h6.5v-3.25h-6.5v-1.625h-1.625v-9.75Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.433,415.654h1.625v-1.625h8.125v1.625h1.625v1.625h-3.25v-1.625h-4.875v13h4.875v-1.625h3.25v1.625h-1.625v1.625h-8.125v-1.625h-1.625v-13Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.433,414.029h3.25v6.5h1.625v-1.625h4.875v1.625h1.625v9.75h-3.25v-9.75h-3.25v1.625h-1.625v8.125h-3.25v-16.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.433,418.904h9.75v1.625h1.625v9.75h-9.75v-1.625h-1.625v-4.875h1.625v-1.625h6.5v-1.625h-8.125v-1.625ZM493.683,423.779v4.875h4.875v-4.875h-4.875Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.433,418.904h3.25v1.625h1.625v-1.625h4.875v1.625h1.625v9.75h-3.25v-9.75h-3.25v1.625h-1.625v8.125h-3.25v-11.375Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.433,420.529h1.625v-1.625h9.75v14.625h-1.625v1.625h-8.125v-1.625h-1.625v-1.625h3.25v1.625h4.875v-3.25h-6.5v-1.625h-1.625v-8.125ZM519.683,420.529v8.125h4.875v-8.125h-4.875Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.433,414.029h3.25v6.5h1.625v-1.625h4.875v1.625h1.625v9.75h-3.25v-9.75h-3.25v1.625h-1.625v8.125h-3.25v-16.25Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.433,418.904h9.75v1.625h1.625v9.75h-9.75v-1.625h-1.625v-4.875h1.625v-1.625h6.5v-1.625h-8.125v-1.625ZM545.683,423.779v4.875h4.875v-4.875h-4.875Z",
    fill: "#000",
    strokeWidth: 0
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M517.838,344.404h5.88v2.95h-5.88v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.838,335.593h2.95v2.95h-2.95v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.907,341.473h2.931v2.931h-2.931v-2.931Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.838,335.593v-2.931h-2.931v-20.572h-2.95v11.761h-2.931v2.931h2.931v14.691h2.95v-5.88h2.931Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.027,309.16h2.931v2.931h-2.931v-2.931Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.096,315.04h2.931v5.861h-2.931v-5.861Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.146,306.21h5.88v2.95h-5.88v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.713,326.782h32.313v2.931h-32.313v-2.931Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.146,312.09h2.95v2.95h-2.95v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.644,320.901h26.452v2.95h-26.452v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.266,344.404h2.95v2.95h-2.95v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.266,335.593h2.95v5.88h-2.95v-5.88Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.335,315.04h5.88v2.931h-5.88v-2.931Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.455,332.662h2.95v11.742h-2.95v-11.742Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.524,344.404h2.931v2.95h-2.931v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.455,306.21v11.761h2.95v-11.761h8.811v-2.931h2.931v-2.931h2.95v-2.95h2.931v-8.811h-11.761v2.95h-2.931v2.931h-2.931v2.931h-2.95v5.88h-2.931v2.931h2.931ZM494.335,297.399h2.931v-2.931h2.95v-2.931h2.931v2.931h-2.931v2.931h-2.95v2.95h-2.931v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.644,312.09h5.88v2.95h-5.88v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.644,335.593h2.95v5.88h-2.95v-5.88Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.713,306.21h5.88v2.95h-5.88v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.713,315.04h2.931v5.861h-2.931v-5.861Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.764,323.851v-11.761h-2.931v23.502h-5.88v2.95h5.88v2.931h2.931v-14.691h2.95v-2.931h-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.764,309.16h2.95v2.931h-2.95v-2.931Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.764,291.538v8.811h2.95v2.931h8.811v-5.88h-5.88v-2.931h-2.931v-2.931h-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.902,341.473h2.931v2.931h-2.931v-2.931Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.953,344.404h2.95v2.95h-2.95v-2.95Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.022,332.662h2.931v2.931h-2.931v-2.931Z",
    fill: "#000",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.2e20b00d5155bcd96f3a6c6983ddb044.svg";
export { ForwardRef as ReactComponent };